/**
 * Created by Carsten Hibbeler on 22.02.2016.
 */
'use strict';

let supportFunctionNameRenameing = false;
try {
    const supportFn = Object.getOwnPropertyDescriptor(() => {
    }, 'name');
    supportFunctionNameRenameing = supportFn && supportFn.configurable;
} catch (e) {
    console.error(e);
}

export function namedApi(namespace, api) {
    try {
        Object.keys(api).forEach(fn => {
            if (supportFunctionNameRenameing) {
                Object.defineProperty(api[ fn ], 'name', {
                    value: namespace + '.' + fn
                });
            }
            api[ fn ].__name = namespace + '.' + fn;
        });
    } catch (e) {
        console.error(e);
    }
}

export function apiName(api) {
    return api && (api.__name || api);
}

export function apiCall(promise, meta) {
    return { promise, meta };
}

export function asUrlCall(service, method, methodParms, urlParams) {
    let url = service + '/' + method + '/';

    for (let property in methodParms) {
        if (methodParms.hasOwnProperty(property)) {
            const param = methodParms[ property ];
            if (Array.isArray(param)) {
                url += property + '/' + encodeURIComponent(param, '') + '/';
            }
            else if (typeof param === 'object') {
                url += property + '/' + JSON.stringify(param, '') + '/';
            } else {
                url += property + '/' + param + '/';
            }

        }
    }

    url += '?p_auth=' + Liferay.authToken;
    if (urlParams && urlParams.length > 0) {
        url += '&' + urlParams;
    }

    return url;
}



// WEBPACK FOOTER //
// ./js/utils/api-util.js